import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SetupMembershipPage } from './setup-membership.page';

const routes: Routes = [
  {
    path: '',
    component: SetupMembershipPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SetupMembershipPageRoutingModule {}
